const capitalize = (array: string[]) => {
  const capitalizedArray: string[] = [];

  array.forEach(value => {
    capitalizedArray.push(value.charAt(0).toUpperCase() + value.substring(1));
  });

  return capitalizedArray;
};

export { capitalize };
